import { connect } from "react-redux";
import Map from "../components/Map";
import * as actions from "../actions";
import * as selectors from "../selectors";
import { history } from "../store";
import { getEnvSetting } from "../utils/env";
import { queryStringToFilters } from "../utils/filters";

const mapStateToProps = (state, ownProps) => {
  const filters = queryStringToFilters(location.search);

  return {
    tilesUrl: getEnvSetting("REACT_APP_TILES_URL"),
    user: selectors.getUser(state),
    districts: selectors.getDistricts(state),

    districtsFilter: filters.districts,
    categoriesFilter: filters.categories,
    freetextFilter: filters.freetext,
    offbordersFilter: filters.offborders,

    isLoadingDistricts: selectors.isLoadingDistricts(state),
    isLoadingCategories: selectors.isLoadingCategories(state),
    institutions: selectors.getInstitutions(state),
    activeInstitution: selectors.getActiveInstitution(state),
    className: ownProps.className
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSetActiveInstitution: id => dispatch(actions.setActiveInstitution(id)),
    onEditInstitution: key => dispatch(actions.editInstitution(key)),
    onOpenDetailView: key => history.push(`/view/${key}`),
    onSearchTag: (tag, districts, categories, offborders) =>
      dispatch(
        actions.setFilters({
          active: null,
          freetext: tag,
          districts,
          categories,
          offborders
        })
      )
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Map);



/** WEBPACK FOOTER **
 ** ./src/containers/MapContainer.js
 **/